import { render, staticRenderFns } from "./SetUpSecurityQuestions.vue?vue&type=template&id=15922b99&scoped=true&"
import script from "./SetUpSecurityQuestions.vue?vue&type=script&lang=js&"
export * from "./SetUpSecurityQuestions.vue?vue&type=script&lang=js&"
import style0 from "./SetUpSecurityQuestions.vue?vue&type=style&index=0&id=15922b99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15922b99",
  null
  
)

export default component.exports